import axios from "axios";
import { getToken } from "./token";

// Prefer same-origin API calls for Railway staging so nginx can proxy traffic
// privately to the backend. A public backend URL can still be injected at build
// time for other deployment targets.
const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Append ?auth=token so <img src> can authenticate against gated files
export const fileUrl = (path) => {
  if (!path) return "";
  const token = getToken();
  return token ? `${API}/files/${path}?auth=${encodeURIComponent(token)}` : `${API}/files/${path}`;
};
